export const colors = {
  main: "#FF0101",
  darkgray: "#4B465C",
  lightgray: "#6F6B7D",
  gray: "#A8AAAE",
};
